/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './status-modal.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../app/components/modals/status-modal/status-modal.component';
import * as i5 from 'ngx-bootstrap/modal/modal-options.class';
import * as i6 from '@angular/router';
import * as i7 from '../../../../../app/shared/_services/hotel-management.service';
import * as i8 from '../../../../../app/shared/_services/marketing.service';
const styles_StatusModalComponent:any[] = [i0.styles];
export const RenderType_StatusModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_StatusModalComponent,data:{}});
function View_StatusModalComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'input',[['autocomplete',
      'off'],['class','form-control'],['id','dText']],[[2,'ng-untouched',(null as any)],
      [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
          (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
      [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
      'keyup'],[(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
      [(null as any),'compositionend']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,1)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_4:any = ((<any>(_co.duplicatedValue = $event)) !== false);
      ad = (pd_4 && ad);
    }
    if (('keyup' === en)) {
      const pd_5:any = ((<any>_co.trimText($event)) !== false);
      ad = (pd_5 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i1.ɵdid(3,671744,(null as any),0,i2.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(5,16384,(null as any),0,
          i2.NgControlStatus,[i2.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = _co.duplicatedValue;
    _ck(_v,3,0,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,5).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,5).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,5).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,5).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,5).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,5).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_StatusModalComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),10,'div',[['class',
      'modal-header']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),1,'h3',[['class','modal-title'],['id','exampleModalLabel']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(3,(null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(5,0,(null as any),(null as any),1,'p',[['xngIf','(srcObject.status == \'Active\' || srcObject.status == null)']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(6,(null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StatusModalComponent_2)),
      i1.ɵdid(9,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_2:any = (_co.srcObject.status == 'Duplicated');
        _ck(_v,9,0,currVal_2);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.srcObject.title;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.srcObject.message;
        _ck(_v,6,0,currVal_1);
      });
}
function View_StatusModalComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'button',[['class',
      'btn btn-default'],['data-dismiss','modal'],['type','button']],[[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.action1()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,278528,(null as any),0,i3.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),(_l()(),i1.ɵted(2,(null as any),['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'btn btn-default';
    const currVal_2:any = ((_co.srcObject.style == 'active')? 'active': 'inactive');
    _ck(_v,1,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = (!_co.duplicatedValue || (_co.duplicatedValue == ''));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = _co.srcObject.action1;
    _ck(_v,2,0,currVal_3);
  });
}
function View_StatusModalComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'button',[['class',
      'btn btn-default'],['data-dismiss','modal'],['type','button']],(null as any),
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.action1()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,278528,(null as any),0,i3.NgClass,
      [i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{klass:[0,
          'klass'],ngClass:[1,'ngClass']},(null as any)),(_l()(),i1.ɵted(2,(null as any),
      ['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'btn btn-default';
    const currVal_1:any = ((_co.srcObject.style == 'active')? 'active': 'inactive');
    _ck(_v,1,0,currVal_0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.srcObject.action1;
    _ck(_v,2,0,currVal_2);
  });
}
function View_StatusModalComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),10,'div',[['class',
      'modal-footer text-center']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['  \n  '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),1,'button',[['class','btn btn-default'],['data-dismiss',
          'modal'],['id','deleteModal'],['type','button']],(null as any),[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.confirmClose()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),['',''])),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_StatusModalComponent_4)),i1.ɵdid(6,16384,(null as any),
      0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_StatusModalComponent_5)),i1.ɵdid(9,16384,
          (null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = (_co.srcObject.status == 'Duplicated');
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = (_co.srcObject.status != 'Duplicated');
    _ck(_v,9,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.srcObject.action2;
    _ck(_v,3,0,currVal_0);
  });
}
export function View_StatusModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_StatusModalComponent_1)),i1.ɵdid(1,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_StatusModalComponent_3)),i1.ɵdid(4,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i4.StatusModalComponent = _v.component;
    const currVal_0:any = (_co.srcObject.mode == 'custom');
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.srcObject.mode == 'custom');
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_StatusModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-status-modal',
      ([] as any[]),(null as any),(null as any),(null as any),View_StatusModalComponent_0,
      RenderType_StatusModalComponent)),i1.ɵdid(1,114688,(null as any),0,i4.StatusModalComponent,
      [i5.BsModalRef,i6.Router,i7.HotelManagementService,i8.MarketingService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const StatusModalComponentNgFactory:i1.ComponentFactory<i4.StatusModalComponent> = i1.ɵccf('app-status-modal',
    i4.StatusModalComponent,View_StatusModalComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/modals/status-modal/status-modal.component.ngfactory.ts